export const colorConstants = {
  oddle: '#FF485B',
  oddleHover: '#E64152',
  facebook: '#3A589B',
  facebookHover: '#344F8B',
  google: '#DF4A32',
  googleHover: '#C8422C',
  white: '#FFFFFF',
  black: '#000000',
  matteBlack: '#393939',
  lightGray: '#D6D6D6',
  lightestGray: '#F6F6F6',
  gray: '#BBBBBB',
  green: '#067E30',
  lightGreen: '#DDF7E6',
  blue: '#0C62CA',
  lightBlue: '#D7E9FF',
  red: '#D62105',
  lightRed: '#FFEEEB',
  yellow: '#FFCF35',
  lightYellow: '#FFF1BB',
  transparent: 'transparent',
  defaultText: '#515151',
  oddleEats: '#350893',
  progressBarError: '#D0021B',
  progressBarColor: '#27CA27',
  mainVoucherColor: '#0A3040'
}

export const colors = {
  brandPrimary: colorConstants.oddle,
  brandPrimaryDark: colorConstants.oddleHover,
  brandPrimaryDarkest: '#992B37',
  brandPrimaryLight: '#FF6D7C',
  brandPrimaryLightest: '#FFE3E6',
  brandSecondary: '#23537E',
  heading: colorConstants.matteBlack,
  text: colorConstants.defaultText,
  buttonText: colorConstants.white,
  background: '#F1F1F1',
  separator: colorConstants.lightGray,
  container: colorConstants.white,
  disabled: colorConstants.gray,
  headerBackground: colorConstants.oddle,
  headerNav: colorConstants.white,
  footerBackground: '#16688a',
  footerNav: colorConstants.white,
  toggleOff: colorConstants.gray,
  toggleOn: '#17d254',
  promotionFilmstripPlaceholder: '#F9FAFC',
  alertErrorLight: colorConstants.lightRed,
  alertError: colorConstants.red,
  alternativeHighlightColor: '#2B85EF'
}

export const transition = {
  linear: 'linear',
  playful: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  ease: 'ease'
}

const none = 'none'
const baseSize = 'base'
const extraSmallSize = 'extraSmall'
const smallSize = 'small'
const mediumSize = 'medium'
const largeSize = 'large'
const extraLargeSize = 'extraLarge'

const basePadding = 20
export const paddingSizes = {
  none: none,
  extraSmall: extraSmallSize,
  small: smallSize,
  medium: mediumSize,
  large: largeSize,
  extraLarge: extraLargeSize
}
export const padding = {
  [paddingSizes.none]: '0',
  [paddingSizes.extraSmall]: `${0.25 * basePadding}px`,
  [paddingSizes.small]: `${0.5 * basePadding}px`,
  [paddingSizes.medium]: `${basePadding}px`,
  [paddingSizes.large]: `${1.5 * basePadding}px`,
  [paddingSizes.extraLarge]: `${2.25 * basePadding}px`
}

const baseMargin = 20
export const marginSizes = {
  none: none,
  extraSmall: extraSmallSize,
  small: smallSize,
  medium: mediumSize,
  large: largeSize,
  extraLarge: extraLargeSize
}
export const margin = {
  [baseSize]: `${baseMargin}px`,
  [marginSizes.none]: '0',
  [marginSizes.extraSmall]: `${0.25 * baseMargin}px`,
  [marginSizes.small]: `${0.5 * baseMargin}px`,
  [marginSizes.medium]: `${1 * baseMargin}px`,
  [marginSizes.large]: `${1.5 * baseMargin}px`,
  [marginSizes.extraLarge]: `${2.25 * baseMargin}px`
}

export const borderRadiusSizes = {
  none: none,
  small: smallSize,
  medium: mediumSize,
  large: largeSize
}
export const borderRadius = {
  [borderRadiusSizes.none]: '0px',
  [borderRadiusSizes.small]: '2px',
  [borderRadiusSizes.medium]: '5px',
  [borderRadiusSizes.large]: '30px'
}

export const breakpoints = {
  mobile: '480px',
  tablet: '720px',
  desktop: '1024px'
}

export const gutterSize = {
  mobile: 16,
  tablet: 16,
  desktop: 32
}

export const columns = 12

export const typo = {
  base: {
    mobileFontSize: '16px',
    tabletFontSize: '16px',
    desktopFontSize: '16px'
  },
  fontWeights: {
    regular: 400,
    bold: 700
  },
  h1: {
    mobileFontSize: '1.5rem',
    tabletFontSize: '1.5rem',
    desktopFontSize: '1.75rem',
    mobileLineHeight: '1.875rem',
    tabletLineHeight: '1.875rem',
    desktopLineHeight: '2.125rem'
  },
  h2: {
    mobileFontSize: '1.25rem',
    tabletFontSize: '1.25rem',
    desktopFontSize: '1.5rem',
    mobileLineHeight: '1.5rem',
    tabletLineHeight: '1.5rem',
    desktopLineHeight: '1.75rem'
  },
  h3: {
    mobileFontSize: '1.125rem',
    tabletFontSize: '1.125rem',
    desktopFontSize: '1.125rem',
    mobileLineHeight: '1.375rem',
    tabletLineHeight: '1.375rem',
    desktopLineHeight: '1.5rem'
  },
  h4: {
    mobileFontSize: '1rem',
    tabletFontSize: '1rem',
    desktopFontSize: '1rem',
    mobileLineHeight: '1.375rem',
    tabletLineHeight: '1.375rem',
    desktopLineHeight: '1.375rem'
  },
  p: {
    mobileFontSize: '1rem',
    tabletFontSize: '1rem',
    desktopFontSize: '1rem',
    mobileLineHeight: '1.375rem',
    tabletLineHeight: '1.375rem',
    desktopLineHeight: '1.375rem'
  },
  smallText: {
    mobileFontSize: '0.75rem',
    tabletFontSize: '0.75rem',
    desktopFontSize: '0.875rem',
    mobileLineHeight: '0.875rem',
    tabletLineHeight: '0.875rem',
    desktopLineHeight: '1rem'
  }
}

export const iconSizes = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  extraLarge: 'extraLarge'
}

export const iconSizesInPixel = {
  small: '12px',
  medium: '18px',
  large: '27px',
  extraLarge: '41px'
}

export const dropShadowVariations = {
  none: 'none',
  light: 'light',
  heavy: 'heavy',
  heaviest: 'heaviest'
}
export const dropShadows = {
  [dropShadowVariations.none]: '0 0 0 rgba(0,0,0,0)',
  [dropShadowVariations.light]: '0 2px 4px rgba(0,0,0,0.2)',
  [dropShadowVariations.heavy]: '0 0 8px rgba(0,0,0,0.2)',
  [dropShadowVariations.heaviest]: '0 0 20px rgba(0,0,0,0.4)'
}

export const buttonStyles = {
  solid: 'solid',
  outline: 'outline',
  raised: 'raised'
}

export const buttonShapes = {
  square: 'square',
  round: 'round',
  pill: 'pill'
}

export const buttonRadiusValues = {
  [buttonShapes.square]: borderRadius[borderRadiusSizes.none],
  [buttonShapes.round]: borderRadius[borderRadiusSizes.medium],
  [buttonShapes.pill]: borderRadius[borderRadiusSizes.large]
}

export const button = {
  buttonShape: buttonShapes.round,
  buttonStyle: {
    primary: buttonStyles.solid,
    secondary: buttonStyles.outline
  },
  backgroundColor: {
    primary: colors.brandPrimary,
    primaryDark: colors.brandPrimaryDark,
    primaryDarkest: colors.brandPrimaryDarkest,
    secondary: colors.buttonText,
    secondaryDark: colors.brandPrimaryDark
  },
  color: {
    primary: colors.buttonText,
    primaryDark: colors.buttonText,
    secondary: colors.brandPrimary,
    secondaryDark: colors.buttonText
  }
}

export const facebookButton = {
  buttonStyle: buttonStyles.solid,
  buttonColor: colorConstants.facebook,
  buttonTextColor: colorConstants.white,
  hoverButtonColor: colorConstants.facebookHover
}

export const googleButton = {
  buttonStyle: buttonStyles.solid,
  buttonColor: colorConstants.google,
  buttonTextColor: colorConstants.white,
  hoverButtonColor: colorConstants.googleHover
}

export const feastBumpButton = {
  buttonStyle: buttonStyles.solid,
  buttonColor: colorConstants.oddle,
  buttonTextColor: colorConstants.white,
  hoverButtonColor: colorConstants.oddleHover
}

export const modal = {
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    transition: transition.ease,
    transitionDuration: 300
  },
  container: {
    backgroundColor: colors.container,
    transition: transition.ease,
    transitionDuration: 300
  },
  header: {
    backgroundColor: colors.container,
    height: 70,
    border: '1px solid rgba(0, 0, 0, 0.1)'
  },
  content: {
    backgroundColor: colors.background
  }
}

export const states = {
  success: 'success',
  informative: 'informative',
  warning: 'warning',
  error: 'error',
  draft: 'draft'
}

export const stateThemes = {
  dark: 'dark',
  light: 'light'
}

export const stateColors = {
  backgroundColors: {
    [states.success]: {
      [stateThemes.dark]: colorConstants.green,
      [stateThemes.light]: colorConstants.lightGreen
    },
    [states.informative]: {
      [stateThemes.dark]: colorConstants.blue,
      [stateThemes.light]: colorConstants.lightBlue
    },
    [states.warning]: {
      [stateThemes.dark]: colorConstants.yellow,
      [stateThemes.light]: colorConstants.lightYellow
    },
    [states.error]: {
      [stateThemes.dark]: colorConstants.red,
      [stateThemes.light]: colorConstants.lightRed
    },
    [states.draft]: {
      [stateThemes.dark]: colorConstants.transparent,
      [stateThemes.light]: colorConstants.transparent
    }
  },
  colors: {
    [states.success]: {
      [stateThemes.dark]: colorConstants.lightGreen,
      [stateThemes.light]: colorConstants.green
    },
    [states.informative]: {
      [stateThemes.dark]: colorConstants.lightBlue,
      [stateThemes.light]: colorConstants.blue
    },
    [states.warning]: {
      [stateThemes.dark]: colorConstants.black,
      [stateThemes.light]: colorConstants.black
    },
    [states.error]: {
      [stateThemes.dark]: colorConstants.lightRed,
      [stateThemes.light]: colorConstants.red
    },
    [states.draft]: {
      [stateThemes.dark]: colorConstants.black,
      [stateThemes.light]: colorConstants.white
    }
  },
  borderColors: {
    [states.success]: {
      [stateThemes.dark]: colorConstants.green,
      [stateThemes.light]: colorConstants.lightGreen
    },
    [states.informative]: {
      [stateThemes.dark]: colorConstants.blue,
      [stateThemes.light]: colorConstants.lightBlue
    },
    [states.warning]: {
      [stateThemes.dark]: colorConstants.yellow,
      [stateThemes.light]: colorConstants.lightYellow
    },
    [states.error]: {
      [stateThemes.dark]: colorConstants.red,
      [stateThemes.light]: colorConstants.lightRed
    },
    [states.draft]: {
      [stateThemes.dark]: colorConstants.black,
      [stateThemes.light]: colorConstants.white
    }
  }
}

export const accordion = {
  container: {
    padding: padding[paddingSizes.small],
    margin: margin[marginSizes.small],
    background: colorConstants.white
  },
  header: {
    padding: padding[paddingSizes.none],
    background: colorConstants.transparent,
    color: colors.text
  }
}

// TODO: move to fesc
export const paymentTypeCard = {
  highlightColor: colorConstants.black
}

export const horizontalNav = {
  height: '70px'
}

export const mobileSideNav = {
  width: '300px'
}

export const checkoutPage = {
  backgroundHeader: {
    height: '300px'
  },
  mobileHeader: {
    height: '60px'
  },
  checkbox: {
    color: colors.brandPrimary
  }
}

export const thankYouPage = {
  backgroundHeader: {
    height: '300px'
  }
}

export const paymentInvoicePage = {
  backgroundHeader: {
    height: '300px'
  }
}

export const coloredBackground = {
  headerHeight: '300px'
}

export const cartDrawer = {
  headerHeight: '80px',
  footerHeight: '96px',
  appointmentContainerHeight: '230px'
}

export const header = {
  desktopHeight: 80,
  mobileHeight: 60,
  linkOpacityOnHover: 0.8,
  dropdownMenuOffset: '68px'
}

export const footer = {
  linkOpacityOnHover: 0.8
}

export const responsiveSection = {
  width: 1200
}

export const promotionFilmStripSection = {
  mobileHeight: '220px',
  desktopHeight: '245px',
  // minus the height of the banner image (100px for mobile, 120px for desktop)
  mobileHideHeight: '120px',
  desktopHideHeight: '125px'
}

export const formLabelScaleRatio = 0.7

export const iframeSection = {
  mobile: '300px',
  tablet: '450px',
  desktop: '600px'
}
